import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

const NoteBox = ({ title, content }) => {
  return (
    <div className="flex items-center bg-yellow-50 border border-yellow-300 rounded p-3 space-x-4">
      <div className="flex items-center justify-center text-yellow-500">
        {/* Icône (par exemple un SVG ou une icône d'une bibliothèque comme FontAwesome) */}
        <div>
          <ExclamationTriangleIcon className="w-6 h-6"></ExclamationTriangleIcon>
        </div>
      </div>
      <div>
        <h4 className="font-bold text-yellow-700">{title}</h4>
        <p className="text-yellow-700">{content}</p>
      </div>
    </div>
  );
};

export default NoteBox;
